import React from "react";
import "./Offices.css";
const Offices = () => {
  return (
    <div>
      <div className="office-details" id="office-heading">
        <h2>Our Offices</h2>
        <ul className="office-list">
          <li>
            <strong>PAKISTAN:</strong> Islamabad
          </li>
          <li>
            <strong>UAE:</strong> Dubai
          </li>
          <li>
            <strong>Indonesia</strong> Jakarta
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Offices;
